
export const common = () => {

      $(function () {
            $(".js-toggle").on('click', function () {
                  $(".js-toggle-list").slideToggle();
            });
      });

      $(function () {

            var winW = 0;

            function SpMenuObject() {
                  this.initialize();
            }
            SpMenuObject.prototype = {
                  'initialize': function () {
                        this.$_menuBtn = $('#js-spMenuBtn');
                        this.$_menu = $('#js-responsive_menu');

                        this.state = 0;

                        this.handleEvents();
                  },
                  'handleEvents': function () {
                        var self = this;

                        self.$_menuBtn.on('click', function () {
                              if (self.state === 1) {
                                    self.close();
                              } else {
                                    self.open();
                              }
                        });
                  },
                  'open': function (target) {
                        this.$_menuBtn.addClass('active');
                        this.$_menu.fadeIn();
                        this.state = 1;
                  },
                  'close': function (target) {
                        this.$_menuBtn.removeClass('active');
                        this.$_menu.fadeOut();
                        this.state = 0;
                  }
            }

            function FixNaviObject() {
                  this.initialize();
            }
            FixNaviObject.prototype = {
                  'initialize': function () {
                        this.$_menu = $('#js-fixNavi');

                        this.scroll = $(window).scrollTop();
                        this.state = 0;

                        if (640 < $(window).width()) {
                              return false;
                        }

                        this.handleEvents();
                  },
                  'handleEvents': function () {
                        var self = this;

                        $(window).on('load', function () {
                              self.scroll = $(window).scrollTop();
                              self.scrollEvent();
                        });
                        $(window).on('scroll', function () {
                              self.scroll = $(window).scrollTop();
                              self.scrollEvent();
                        });
                  },
                  'scrollEvent': function () {
                        if (this.scroll < 120) {
                              this.fadeOut();
                              return false;
                        }
                        this.fadeIn();
                  },
                  'fadeIn': function (target) {
                        var self = this;
                        if (self.state === 0) {
                              self.$_menu.fadeIn(300, function () {
                                    self.state = 1;
                              });
                        }
                  },
                  'fadeOut': function (target) {
                        var self = this;
                        if (self.state === 1) {
                              self.$_menu.fadeOut(300, function () {
                                    self.state = 0;
                              });
                        }
                  }
            }

            $(function () {
                  winW = $(this).width();
                  new SpMenuObject();
                  new FixNaviObject();

                  $(window).on('load resize', function () {
                        winW = $(this).width();
                  });
            });

      });
      
      $(function(){
		
            $('#sitemap_open').click(function(){
                  
                  var footer = $('.footer_navi').offset().top;
                  var position = footer + 500;
                  
                  $("html, body").animate({scrollTop:position},{queue:false},1000);
            });
      });
	  $(function() {
		$('#js-cal-policy input').change(function() {
			if ($(this).prop('checked')) {
				$('#js-send-button li').removeClass("is-disable");
			} else {
				$('#js-send-button li').addClass("is-disable");
			}
		});
	  });
	  $(function() {
		$("#js-contact-policy input").change(function() {
			if ($(this).prop('checked')) {
				$("#js-contact-submit").removeClass("is-disable");
			} else {
				$("#js-contact-submit").addClass("is-disable");
			}
		});
	  });

};